










































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  SurveyItem,
  CheckBoxItemValue,
  OptionTextArea
} from "@/models/SurveyItem";
import { ValidationProvider } from "vee-validate";

@Component({
  components: {
    ValidationProvider
  }
})
export default class CheckBoxItem extends Vue {
  @Prop({ type: Object })
  item!: SurveyItem;

  @Prop({
    type: Object,
    default: () => {
      return new CheckBoxItemValue([]);
    }
  })
  value!: CheckBoxItemValue;

  @Prop({ type: Number, default: 0 })
  langValue!: number;

  localValue: CheckBoxItemValue = new CheckBoxItemValue([]);
  localText!: OptionTextArea[];
  checkBoxRules = { required: false, max: 10, checkBoxOptionTextArea: "" };
  isImmidiate = false;

  created() {
    this.checkBoxRules = { ...this.checkBoxRules, ...this.item.rules };
    if (this.value.selected.length === 0) {
      this.loadLocalValue();
      this.emitLocalValue();
    } else if (this.value !== null && 1 < this.value.selected.length) {
      this.localValue = this.value;
    } else {
      this.localValue = new CheckBoxItemValue([]);
    }
    this.loadLocalText();
    this.updateCheckBoxRules();
  }

  getLocalText(id: string) {
    return this.localText.find(v => v.id === id)?.text ?? "";
  }

  getOptionIdWithTextArea() {
    return this.item.options.filter(v => v.isTextArea).map(v => v.id);
  }

  isDisabled(id: string) {
    let ret = true;
    this.localValue.selected.forEach(v => {
      if (v === id) {
        ret = false;
      }
    });
    return ret;
  }

  loadLocalValue() {
    try {
      this.localValue = JSON.parse(
        localStorage.getItem(this.item.id) ?? ""
      ) as CheckBoxItemValue;
    } catch (e) {
      this.localValue = new CheckBoxItemValue([]);
    }
  }

  loadLocalText() {
    this.localText = [];
    const ids = this.getOptionIdWithTextArea();
    ids.forEach(id => {
      const text = localStorage.getItem(this.item.id + id) ?? "";
      this.localText.push(new OptionTextArea(id, text));
    });
  }

  saveLocalValue() {
    localStorage.setItem(this.item.id, JSON.stringify(this.localValue));
  }

  saveLocalText() {
    this.localText.forEach(v => {
      localStorage.setItem(this.item.id + v.id, v.text);
    });
  }

  emitLocalValue() {
    this.$emit("input", this.localValue);
  }

  async validate() {
    type ValidationProviderRef = InstanceType<typeof ValidationProvider>;
    await (this.$refs.validationProvider as ValidationProviderRef).validate();
  }

  updateCheckBoxRules() {
    this.checkBoxRules.checkBoxOptionTextArea = JSON.stringify(this.localValue);
  }

  updateValue() {
    if (!this.isImmidiate) {
      // ライブラリであるvee-validationの不具合対策
      // 初回画面表示の際、1番目以外のチェックボックスでも入力チェックを実施するのための対策
      this.isImmidiate = true;
    }
    this.localValue.optionTextArea = [];
    const ids = this.getOptionIdWithTextArea();
    this.localValue.selected.forEach(v => {
      if (ids.indexOf(v) !== -1) {
        const text = this.getLocalText(v);
        this.localValue.optionTextArea?.push(new OptionTextArea(v, text));
      }
    });
    this.saveLocalValue();
    this.emitLocalValue();
    this.updateCheckBoxRules();
  }

  updateText(id: string, text: string) {
    this.localText.filter(v => v.id === id).forEach(v => (v.text = text));
    this.saveLocalText();
    this.localValue.optionTextArea?.forEach(v => {
      if (v.id === id) {
        v.text = text;
      } else {
        this.localValue.optionTextArea?.push(new OptionTextArea(id, text));
      }
    });
    this.saveLocalValue();
    this.emitLocalValue();
    this.updateCheckBoxRules();
    this.validate();
  }
}
